import { render, staticRenderFns } from "./menu-popover.vue?vue&type=template&id=703a2aea&scoped=true"
import script from "./menu-popover.vue?vue&type=script&lang=js"
export * from "./menu-popover.vue?vue&type=script&lang=js"
import style0 from "./menu-popover.vue?vue&type=style&index=0&id=703a2aea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703a2aea",
  null
  
)

export default component.exports